module.exports = __webpack_public_path__ + "media/assets/icons/link-fill-272ba2763b0c5f16e0e8d33beebe8f19.svg";